import { Button } from "antd";
import { useLocation } from "react-router-dom";
import DogImg from "@shared/assets/webp/builddog.webp";
import { useNavigate } from "@shared/lib/react-router";
import { BaseErrorPage } from "@shared/ui/error-fallbacks/base-error-page.tsx";
import { isUnifiedRoute } from "@shared/utils";

interface NotFoundPageProps {
  className?: string;
  status?: number;
}

export const HttpStatusTypes = {
  NotFound: 404,
  Forbidden: 403,
  Unauthorized: 401,
  InternalServerError: 500,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  BadRequest: 400,
  Conflict: 409,
  Gone: 410,
  UnprocessableEntity: 422,
  TooManyRequests: 429,
} as const;

export type HttpStatus = (typeof HttpStatusTypes)[keyof typeof HttpStatusTypes];

export const HttpStatusRu: Record<number, string> = {
  [HttpStatusTypes.NotFound]: "Страница не найдена",
  [HttpStatusTypes.Forbidden]: "Доступ запрещён",
  [HttpStatusTypes.Unauthorized]: "Неавторизован",
  [HttpStatusTypes.InternalServerError]: "Внутренняя ошибка сервера",
  [HttpStatusTypes.BadGateway]: "Плохой шлюз",
  [HttpStatusTypes.ServiceUnavailable]: "Сервис недоступен",
  [HttpStatusTypes.GatewayTimeout]: "Время ожидания шлюза истекло",
  [HttpStatusTypes.BadRequest]: "Некорректный запрос",
  [HttpStatusTypes.Conflict]: "Конфликт",
  [HttpStatusTypes.Gone]: "Ресурс удалён",
  [HttpStatusTypes.UnprocessableEntity]: "Необрабатываемый экземпляр",
  [HttpStatusTypes.TooManyRequests]: "Слишком много запросов",
};

export function NotFoundFallback({
  className,
  status,
}: NotFoundPageProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isUnified = isUnifiedRoute(location.pathname);

  const handleClick = () => {
    navigate(-1);
  };

  const handleHomeClick = () => {
    navigate("/");
  };

  // Если status не определён или не входит в список известных, используем 404
  const resolvedStatus =
    typeof status === "number" && HttpStatusRu[status]
      ? status
      : HttpStatusTypes.NotFound;
  
  return (
    <BaseErrorPage
      className={className}
      title={`${resolvedStatus}. ${HttpStatusRu[resolvedStatus]}`}
      description={
        <span>
          {!isUnified && (
            <div>
              Возвращайтесь на{" "}
              <span onClick={handleHomeClick} className="base-error-page-link">
                Главную страницу
              </span>
              {", "}
              или
            </div>
          )}
          <Button type="link" onClick={handleClick} className="base-error-page-link">
            Вернуться назад
          </Button>
        </span>
      }
      asset={<img width={140} height={216} src={DogImg} alt="BuildDog" />}
    />
  );
}
